// import "./src/theme/GreenishBlueColors";
import "./App.css";
// import logo from "./logo.svg";

import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import CookieConsent from "./components/CookieConsent";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Gifts from "./pages/Gifts";
import TestPage from "./pages/TestPage";
import LegalInformation from "./pages/LegalInformation";
import CookiesPolicy from "./pages/CookiesPolicy";
import { getCountry } from "./utils/getCountry";

function App() {
  const [selectedCountry, setSelectedCountry] = useState("Canada");
  useEffect(() => {
    setSelectedCountry(getCountry(selectedCountry));
  }, []);

  return (
    <div>
      <CookieConsent />
      <Router>
        <div
          style={{
            zIndex: 100,
          }}
        >
          <Navbar
            selectedCountry={selectedCountry}
            setSelectedCountry={setSelectedCountry}
          />
        </div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ flex: 5 }}>
            <Routes>
              <Route
                path="/"
                element={<Home selectedCountry={selectedCountry} />}
              />
              <Route path="/cookies" element={<CookiesPolicy />} />
              <Route
                path="/gifts"
                element={<Gifts selectedCountry={selectedCountry} />}
              />
              <Route path="/legal" element={<LegalInformation />} />
              <Route path="/test" element={<TestPage />} />
            </Routes>
          </div>
        </div>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
